import React from "react";
import { useHistory } from "react-router-dom";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import {
  myLeavePreviousFulfilledLeavesTableDef as previousFulfilledLeavesTableDef,
  previousFulfilledLeavesisMobile as previousFulfilledLeavesisMobileTableDef,
} from "my-leave/configs/table-defs";
import { MY_LEAVE_LEAVES_SUBSCRIPTION } from "my-leave/graphql";
import { MY_LEAVE_GET_YEARLY_DAYS_BY_CONTRACT } from "my-leave/graphql";
import { OcDataTable } from "oc/components";
import { initialTableData } from "oc/configs/initial-table-data";
import {
  useOcTableState,
  useOcCurrentUserState,
  useOcPolling,
} from "oc/hooks";
// Importáljuk a két tableDef-et
import getSortedList from "oc/utils/get-sorted-list";

export const MyLeavePreviousFulfilledLeavesTable = ({
  isMobile,
}: {
  isMobile: boolean;
}) => {
  const history = useHistory();
  let thisYear = new Date().getFullYear().toString();

  let { contractCode } = useOcCurrentUserState();

  const { data, loading, refetch } = useQuery(
    MY_LEAVE_GET_YEARLY_DAYS_BY_CONTRACT,
    {
      skip: !contractCode || !thisYear,
      pollInterval: useOcPolling(1000 * 60),
      fetchPolicy: "cache-and-network",
      variables: { contract: contractCode, year: thisYear },
    },
  );

  useSubscription(MY_LEAVE_LEAVES_SUBSCRIPTION, {
    skip: !contractCode,
    onData: () => {
      refetch();
    },
  });
  interface LeaveYearlyDaysByContractItem {
    _id: string;
    year: string;
    availableLeaveDays: number;
    availableStudyLeaveDays: number;
    availableESZJTV19LeaveDays: number;
    availableCovidPlus10LeaveDays: number;
    availableEmergencyLeaveDays: number;
    fulfilledLeaveDays: number;
    fulfilledStudyLeaveDays: number;
    fulfilledAbsenceDays: number;
    fulfilledCovidPlus10Days: number;
    fulfilledESZJTV19Days: number;
    fulfilledEmergencyDays: number;
  }

  let result: LeaveYearlyDaysByContractItem[] =
    data?.leaveYearlyDaysByContract || [];

  let now = new Date();
  let filteredResult = result?.filter(
    (item: LeaveYearlyDaysByContractItem) =>
      item.year !== now.getFullYear().toString(),
  );

  const previousFulfilledLeaves = filteredResult.map((item) => {
    let translatedItem = {
      _id: item?._id,
      year: item.year,
      fulfilledLeave: `${item.fulfilledLeaveDays.toLocaleString()}/${item.availableLeaveDays.toLocaleString()}`,
      fulfilledAbsence: item.fulfilledAbsenceDays.toLocaleString(),
    };
    return translatedItem;
  });

  let tableId = "previousFulfilledLeaves";

  const [tableData, setTableData] = useOcTableState(tableId, {
    ...initialTableData,
    sortField: "year",
    sortDirection: "desc",
    pageSize: 5,
    selectedRowKey: "year",
  });

  previousFulfilledLeaves.sort(
    getSortedList(
      tableData?.sortDirection === "asc"
        ? tableData?.sortField
        : `-${tableData?.sortField}`,
    ),
  );

  let list: {
    total: number;
    page: number;
    pageSize: number;
    rows: typeof previousFulfilledLeaves;
  } = {
    total: previousFulfilledLeaves?.length || 0,
    page: tableData?.page,
    pageSize: tableData?.pageSize || initialTableData.pageSize,
    rows: previousFulfilledLeaves || [],
  };

  const [selectedRowId, setSelectedRowId] = React.useState<
    string | number | undefined
  >(undefined);

  const originalonSelectRow = async (o: any) => {
    if (isMobile) {
      history.push(`/my-leave/my-yearly-leaves/${o?.row?.year}`);
    } else {
      history.push(`/my-leave/my-yearly-leaves/${o.year}`);
    }
  };

  const handleSelectedYear = async (o: { year: string; _id?: string }) => {
    if (isMobile) {
      setSelectedRowId(
        selectedRowId === o?._id ? undefined : (o?._id ?? undefined),
      );
    } else {
      await originalonSelectRow(o);
    }
  };

  const tableDef = isMobile
    ? previousFulfilledLeavesisMobileTableDef
    : previousFulfilledLeavesTableDef;

  const filteredTableDef = {
    id: previousFulfilledLeavesTableDef?.id,
    columns: previousFulfilledLeavesTableDef?.columns?.filter(
      (column) =>
        !previousFulfilledLeavesisMobileTableDef?.columns?.some(
          (mobileColumn) => mobileColumn?.id === column?.id,
        ),
    ),
  };

  return (
    <OcDataTable
      data={list}
      loading={loading && data?.rows?.length === 0 ? true : false}
      tableDef={tableDef}
      tableData={tableData}
      setTableData={setTableData}
      pagination={true}
      onSelectRow={handleSelectedYear}
      localPaging={true}
      filteredTableDef={filteredTableDef}
      selectedRowId={selectedRowId}
      handleMoreButton={originalonSelectRow}
    />
  );
};

export default MyLeavePreviousFulfilledLeavesTable;
